import { createContext } from 'react';
import { useApplicationsFormsSchemas } from 'hooks/useApplicationsFormsSchemas';
import { ApplicationFormSchema } from 'common/types/apps-store/application-form-schema';

export const ApplicationsFormsSchemasContext = createContext<{
  isMdmConnected: boolean;
  isApplicationsFormsSchemasLoading: boolean;
  applicationsFormsSchemas: ApplicationFormSchema[];
  applicationTypeToSchema: Record<string, ApplicationFormSchema>;
  applicationDisplayNameToSchema: Record<string, ApplicationFormSchema>;
}>({
  isMdmConnected: false,
  applicationTypeToSchema: undefined,
  applicationsFormsSchemas: undefined,
  isApplicationsFormsSchemasLoading: false,
  applicationDisplayNameToSchema: undefined,
});

export const ApplicationsFormsSchemasProvider = ({
  token,
  children,
  tenantName,
  isRootLogin,
}) => {
  const {
    isLoading,
    isMdmConnected,
    applicationTypeToSchema,
    applicationDisplayNameToSchema,
    data: applicationsFormsSchemas,
  } = useApplicationsFormsSchemas({ token, isRootLogin, tenantName });

  return (
    <ApplicationsFormsSchemasContext.Provider
      value={{
        isMdmConnected,
        applicationTypeToSchema,
        applicationsFormsSchemas,
        applicationDisplayNameToSchema,
        isApplicationsFormsSchemasLoading: isLoading,
      }}
    >
      {children}
    </ApplicationsFormsSchemasContext.Provider>
  );
};
